<template>
  <div>
    <Header></Header>
    <div class="wrapper">
      <div class="top">
        <p class="col-12 top-nav text-left"><span class="index">首页</span><span>&gt;</span><span class="second">发展历程</span></p>
        <div class="row">
          <div class="col-md-5 col-12">
            <p class="title text-left">发展历程</p>
            <p class="green-block"></p>
          </div>
          <div class="col-md-7 col-12 text-left">
            <p class="subtitle">2013</p>
            <p class="desc">3月及时雨成立</p>
            <p class="desc">7月及时雨成为中国小额信贷机构联席会常务理事会员单位</p>
            <p class="desc">12月“及时雨小微金融信息管理系统”项目荣获2013年度上海金融创新成果奖三等奖</p>

            <p class="subtitle">2014</p>
            <p class="desc">6月及时雨成为中国小额贷款公司社会责任报告优秀考察单位</p>
            <p class="desc">7月及时雨成为上海商学院就业实习基地</p>
            <p class="desc">7月及时雨成为上海市首批小贷公司接入央行征信系统试点单位</p>

            <p class="subtitle">2015</p>
            <p class="desc">3月及时雨荣获2014年中国小额贷款公司竞争力100强 </p>
            <p class="desc">6月及时雨成为上海金融信息行业协会副会长单位 </p>

            <p class="subtitle">2016</p>
            <p class="desc">10月及时雨荣获2016全国优秀小额贷款公司 </p>

            <p class="subtitle">2018</p>
            <p class="desc">10月及时雨荣获2018全国优秀小额贷款公司 </p>

            <p class="subtitle">2019</p>
            <p class="desc">3月及时雨荣获2018年度优秀企业金奖 </p>
          </div>
        </div>

      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './Header'
  import Footer from './Footer'

  export default {
    name: "progress",
    components:{Header,Footer},

  }
</script>

<style scoped lang="less">
  p{margin:0;}
  //pc、laptop
  @media screen and (min-width: 769px) {
    .top{
      width:1300px !important;
      /*padding-left:50px;*/
    }
  }

  //phone
  @media screen and (max-width: 768px) {
    .wrapper{
      padding-top:90px;
      font-size: 26px;
    }
    .green-block{
      margin-bottom:100px;
    }
    .desc{
      padding-right:40px;
    }
  }


  .top{
    margin: 60px auto 250px;
    padding-left:50px;

    .top-nav{
      /*font-size:20px;*/
      margin-bottom:48px;

      .index{
        margin-right:10px;
        color:#01A494;
      }
      .second{
        margin-left:10px;
      }
    }
    .row{
      margin:0;
    }

    .title{
      font-size:56px;
      margin-bottom:56px;
    }
    .green-block{
      width:64px;
      height:8px;
      background:rgba(1,164,148,1);
    }
    .subtitle{
      font-size:56px;
      /*margin-bottom:17px;*/
      margin-top:48px;
      font-weight:bold;
      &:first-child{
        margin-top:0;
      }
    }
    .desc{
      margin-bottom: 12px;
      color: rgba(0,0,0,.6)
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Progress.vue